<template>
  <div class="animated fadeIn">
    <b-card-body id="areaImprimir">
      <!--        <b-row >-->
      <!--          <b-col sm="8">-->
      <!--            <h2 class="mb-3"> {{reportType}} de guía de despacho #{{waybill.number}}</h2>-->
      <!--          </b-col>-->
      <!--          <b-col sm="4">-->
      <!--            -->
      <!--            <div id="element-to-hide" data-html2canvas-ignore="true">-->
      <!--              <a href="#" class="btn btn-sm btn-outline-dark float-right" @click="printDiv"><i class="fa fa-lg fa-print"></i></a>&nbsp;-->
      <!--              &lt;!&ndash; <a href="#" class="btn btn-sm btn-success float-right ml-1"><i class="fa fa-send"></i> Enviar</a> &ndash;&gt;-->
      <!--              <a href="#" class="btn btn-sm btn-outline-dark float-right" @click="descargarPDF"><i class="fa fa-lg fa-file-pdf-o"></i></a>&nbsp;-->
      <!--            </div>-->
      <!--          </b-col>-->
      <!--        </b-row>-->
      <b-row class="border-bottom mb-2">
        <b-col>
          <b-img
            :src="img"
            left
            fluid
            style="max-height: 100px"
            alt="Responsive image"
            class="rounded pb-0"
          ></b-img>
          <h1 class="text-right">
            {{ reportType }} <br />
            GUÍA DE DESPACHO #{{ waybill.number }}
          </h1>
          <p class="text-right">{{ waybill.waybill_date | moment }}</p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"
            ><i class="fa fa-download"></i
          ></a>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col sm="4">
          <h6 class="mb-3">Destinatario:</h6>
          <div v-if="waybill.recipient_company != null">
            <div>
              <strong>{{ waybill.recipient_company.company_name }}</strong>
            </div>
            <div>{{ waybill.recipient_company.company_number }}</div>
            <div>{{ waybill.recipient_company.address1 }}</div>
            <div>{{ waybill.recipient_company.address2 }}</div>
            <div>Email: {{ waybill.recipient_company.email }}</div>
            <div>Teléfono: {{ waybill.recipient_company.phone }}</div>
          </div>
          <div v-else>
            Sin destinatario por favor ingréselo editando la guía. HHAHAHA
          </div>
        </b-col>
        <b-col sm="4">
          <h6 class="mb-3">Exportadora Solicitante:</h6>
          <div>
            <strong>{{ waybill.client_customer.company_name }}</strong>
          </div>
          <div>{{ waybill.client_customer.company_number }}</div>
          <div>{{ waybill.client_customer.address1 }}</div>
          <div>{{ waybill.client_customer.address2 }}</div>
          <div>Email: {{ waybill.client_customer.email }}</div>
          <div>Teléfono: {{ waybill.client_customer.phone }}</div>
        </b-col>
        <b-col sm="4">
          <h6 class="mb-3">Detalles:</h6>
          <div>Número de guía de despacho: {{ waybill.number }}</div>
          <div>
            Fecha de guía de despacho: {{ waybill.waybill_date | moment }}
          </div>
          <!--            <div>Fecha/Hora de arribo: {{waybill.arrival_datetime | moment}}</div>-->
          <div>Chofer: {{ waybill.truck_driver }}</div>
          <div>Patente: {{ waybill.license_plate }}</div>
          <div>Emisor: {{ waybill.company.company_name }}</div>
        </b-col>
      </b-row>
      <h6 class="mb-3 font-weight-bold">Detalle de guía de despacho:</h6>
      <div class="table-responsive-sm">
        <table class="table table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="text-center">#</th>
              <th class="align-middle">Lote</th>
              <th class="align-middle">Cod.</th>
              <th class="align-middle">Fam.</th>
              <th class="align-middle">Material</th>
              <th class="text-center align-middle">Cantidad</th>
              <th class="text-center align-middle">Pallets</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in waybill.details">
              <td>{{ index + 1 }}</td>
              <td>{{ item.supply_lot }}</td>
              <td>{{ item.supply_code }}</td>
              <td>{{ item.supply_family }}</td>
              <td>{{ item.supply_name }}</td>
              <td class="text-center align-middle">
                {{ item.quantity | integer }}
              </td>
              <td class="text-center align-middle">
                {{ item.pallet_quantity | integer }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td class="text-center"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="text-right"></td>
              <td class="text-right">TOTALES</td>
              <td class="text-center">{{ total | integer }}</td>
              <td class="text-center">{{ totalPallets | integer }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <b-row class="mt-3">
        <b-col lg="4" sm="5"> Notas: {{ waybill.note }} </b-col>
        <b-col lg="6" sm="6" class="ml-auto"> </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import numeral from "numeral";
import locale from "numeral/locales";

numeral.locale("es");

export default {
  name: "Report",
  props: ["waybill"],
  data() {
    return {
      img: ""
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    integer(value) {
      return numeral(value).format("0,0");
    }
  },
  computed: {
    reportType() {
      return this.waybill.waybill_type === 3 ? "ENTRADA " : "SALIDA ";
    },
    total() {
      return this.waybill.details.reduce((acc, item) => acc + item.quantity, 0);
    },
    totalPallets() {
      return this.waybill.details.reduce(
        (acc, item) => acc + item.pallet_quantity,
        0
      );
    }
  },
  mounted() {
    this.img = localStorage.getItem("img");
  },
  methods: {
    moment: function () {
      return moment();
    },
    printDiv() {
      const prtHtml = document.getElementById("areaImprimir").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.5 },
        filename:
          this.reportType +
          this.waybill.company.name +
          " G" +
          this.waybill.number +
          ".pdf",
        // html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
      };
      html2pdf(element, opt);
    }
  }
};
</script>

<style scoped></style>
